import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { Account } from '../../../shared/models/account.model';
import {
  BLANK_ROUTE,
  PROFILE_ROUTE,
} from './../../../../constants/app-url-constants';
import { AuthServerProvider } from './../../../auth/auth-jwt.service';
import { AccountService } from './../../../shared/services/account.service';
import { BannerImages } from './header.model';
import { HeaderService } from '../header/header.service';
import { environment } from './../../../../environments/environment';
import { LocalStorageService } from 'ngx-webstorage';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANG } from '../../../../constants/app-constants';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['../../../../styles.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  @Input() sidenav: MatSidenav;
  isRequestStart: boolean;
  user: Account;
  profileRoute = PROFILE_ROUTE;
  defaultPath: string;
  brandLogo: BannerImages;
  banners: BannerImages[] = [];

  baseUrl = environment.BRAND_LOGOS_URL;

  acushnetLogo = this.baseUrl + 'acushnet-logo-white.png';
  titleistLogo = this.baseUrl + 'titleist-logo-white.png';
  footjoyLogo = this.baseUrl + 'footjoy-logo-white.png';
  scottyLogo = this.baseUrl + 'scotty-cameron-logo-white.png';
  vokeyLogo = this.baseUrl + 'vokey-logo-white.png';
  linksandkingsLogo = this.baseUrl + 'linksandkings.png';
  clubgloveLogo = this.baseUrl + 'club-glove-logo-white.png';

  constructor(
    private accountService: AccountService,
    private authServerProviderService: AuthServerProvider,
    private router: Router,
    private headerService: HeaderService,
    private $localStorage: LocalStorageService,
    public translate: TranslateService,
    private $gaService: GoogleAnalyticsService
  ) {
    this.defaultPath = 'assets/images/Profile.png';
  }

  ngOnInit() {
    this.getUserDetails();
    this.getImages();
  }
  getUserDetails() {
    this.isRequestStart = true;
    this.accountService.getAuthenticationState().subscribe(
      (user: Account) => {
        this.user = user;
        this.isRequestStart = false;
      },
      () => {
        this.isRequestStart = false;
      }
    );
  }

  onLogout() {
    this.authServerProviderService
      .logout()
      .subscribe((res) => this.$gaService.event('admin_logout'));
    this.router.navigate([BLANK_ROUTE]);
  }
  getImages() {
    this.headerService.getAllImages().subscribe((response: BannerImages[]) => {
      if (response.length) {
        this.banners = response.filter(
          (type) => type.imageType === 'LOGIN_PAGE'
        );
        this.brandLogo = _.find(response, { imageType: 'LOGO' });
        //  this.appLogo = _.find(response, { imageType: 'SEASONONE_APP_LOGO' });
      }
    });
  }

  getBrandLogo(logo: BannerImages) {
    this.brandLogo = logo;
  }

  onChangeLanguage(langCode: string) {
    if (langCode.match(/en-US|en-CA|fr-CA/)) {
      const selectedLang = this.$localStorage.retrieve('selectedLanguage')
        ? this.$localStorage.retrieve('selectedLanguage')
        : DEFAULT_LANG;
      if (selectedLang !== langCode) {
        this.translate.use(langCode).subscribe((data) => {
          this.$localStorage.store(
            'selectedLanguage',
            this.translate.instant(langCode)
          );
        });
      }
    }
  }
}
